import store from '../src/store/index.js';
import { userRoleEnum, getKeyByValue } from "./modules/helpers";

function can(permission) {
    let user = store.state.currentUser;
    let pass = false;

    if (user) {
        if (!user.UserRoleId) return;
        let role = getKeyByValue(userRoleEnum, user.UserRoleId);

        switch (permission) {
            case 'access-admin-sidebar':
                pass = ['SmartSales Admin'].includes(role);
                break;
            case 'access-tenant-user-admin':
                pass = ['Sales Administrator'].includes(role);
                break;
            case 'access-tenant-sidebar':
                pass = ['Sales Administrator', 'Sales Manager', 'Sales Rep'].includes(role);
                break;
            case 'access-dealer-profile':
                pass = ['Sales Administrator'].includes(role);
                break;
            case 'access-sales-tax-form':
                pass = ['Sales Administrator', 'Sales Manager', 'Sales Rep'].includes(role);
                break;
            case 'access-user-lockout':
                pass = ['SmartSales Admin', 'Sales Administrator'].includes(role);
                break;
            case 'see-user-profile-btns-that-are-unneccesary-for-smartsales-admin':
                pass = ['Sales Administrator', 'Sales Manager', 'Sales Rep'].includes(role);
                break;
            case 'access-msAccess-db-upload':
                pass = ['Sales Administrator', 'Sales Manager', 'Sales Rep'].includes(role);
                break;
            case 'edit-products':
                pass = ['Sales Administrator'].includes(role);
                break;
            case 'toggle-manufacturers':
                pass = ['SmartSales Admin'].includes(role);
                break;
            case 'edit-dealer-profile':
                pass = ['Sales Administrator', 'SmartSales Admin'].includes(role);
                break;
            case 'edit-manufacturers':
                pass = ['SmartSales Admin'].includes(role);
                break;
						case 'edit-colleagues':
								pass = ['Sales Administrator', 'SmartSales Admin'].includes(role);
								break;
						case 'upload-configurators':
								pass = user.CanUploadConfigurators || false;
								break;

            default:
                pass = false;
                break;
        }
    }

    return pass;
}

export {
    can
};
